export default __webpack_public_path__ + "static/media/acdc-solar-bg.ec86110b.jpeg";